"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DealToJSON = exports.DealFromJSONTyped = exports.DealFromJSON = exports.instanceOfDeal = void 0;
var runtime_1 = require("../runtime");
var DealAdFormats_1 = require("./DealAdFormats");
var DealNegotiation_1 = require("./DealNegotiation");
var DealPlacements_1 = require("./DealPlacements");
var DealType_1 = require("./DealType");
var DspPartner_1 = require("./DspPartner");
var DspProvider_1 = require("./DspProvider");
var FrequencyCap_1 = require("./FrequencyCap");
var Targets_1 = require("./Targets");
var VideoDeliveryFormat_1 = require("./VideoDeliveryFormat");
/**
 * Check if a given object implements the Deal interface.
 */
function instanceOfDeal(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "seatId" in value;
    isInstance = isInstance && "dsp" in value;
    isInstance = isInstance && "placements" in value;
    isInstance = isInstance && "adFormats" in value;
    isInstance = isInstance && "currencyCode" in value;
    return isInstance;
}
exports.instanceOfDeal = instanceOfDeal;
function DealFromJSON(json) {
    return DealFromJSONTyped(json, false);
}
exports.DealFromJSON = DealFromJSON;
function DealFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'seatId': json['seat_id'],
        'salesforceDealId': !(0, runtime_1.exists)(json, 'salesforce_deal_id') ? undefined : json['salesforce_deal_id'],
        'salesforceOrderId': !(0, runtime_1.exists)(json, 'salesforce_order_id') ? undefined : json['salesforce_order_id'],
        'salesforceOpportunityCode': !(0, runtime_1.exists)(json, 'salesforce_opportunity_code') ? undefined : json['salesforce_opportunity_code'],
        'salesforceLineItemId': !(0, runtime_1.exists)(json, 'salesforce_line_item_id') ? undefined : json['salesforce_line_item_id'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, DealType_1.DealTypeFromJSON)(json['type']),
        'dsp': (0, DspProvider_1.DspProviderFromJSON)(json['dsp']),
        'dspPartner': !(0, runtime_1.exists)(json, 'dsp_partner') ? undefined : (0, DspPartner_1.DspPartnerFromJSON)(json['dsp_partner']),
        'placements': (json['placements'].map(DealPlacements_1.DealPlacementsFromJSON)),
        'adFormats': (json['ad_formats'].map(DealAdFormats_1.DealAdFormatsFromJSON)),
        'videoDeliveryFormats': !(0, runtime_1.exists)(json, 'video_delivery_formats') ? undefined : (new Set(json['video_delivery_formats'].map(VideoDeliveryFormat_1.VideoDeliveryFormatFromJSON))),
        'priceFloorMicroAmount': !(0, runtime_1.exists)(json, 'price_floor_micro_amount') ? undefined : json['price_floor_micro_amount'],
        'budgetMicroAmount': !(0, runtime_1.exists)(json, 'budget_micro_amount') ? undefined : json['budget_micro_amount'],
        'currencyCode': json['currency_code'],
        'targets': !(0, runtime_1.exists)(json, 'targets') ? undefined : (0, Targets_1.TargetsFromJSON)(json['targets']),
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'archivedAt': !(0, runtime_1.exists)(json, 'archived_at') ? undefined : (new Date(json['archived_at'])),
        'pausedAt': !(0, runtime_1.exists)(json, 'paused_at') ? undefined : (new Date(json['paused_at'])),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'acceptedAt': !(0, runtime_1.exists)(json, 'accepted_at') ? undefined : (new Date(json['accepted_at'])),
        'buyerPausedAt': !(0, runtime_1.exists)(json, 'buyer_paused_at') ? undefined : (new Date(json['buyer_paused_at'])),
        'currentNegotiation': !(0, runtime_1.exists)(json, 'current_negotiation') ? undefined : (0, DealNegotiation_1.DealNegotiationFromJSON)(json['current_negotiation']),
        'mediaDurationMs': !(0, runtime_1.exists)(json, 'media_duration_ms') ? undefined : json['media_duration_ms'],
        'frequencyCaps': !(0, runtime_1.exists)(json, 'frequency_caps') ? undefined : (new Set(json['frequency_caps'].map(FrequencyCap_1.FrequencyCapFromJSON))),
    };
}
exports.DealFromJSONTyped = DealFromJSONTyped;
function DealToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'seat_id': value.seatId,
        'salesforce_deal_id': value.salesforceDealId,
        'salesforce_order_id': value.salesforceOrderId,
        'salesforce_opportunity_code': value.salesforceOpportunityCode,
        'salesforce_line_item_id': value.salesforceLineItemId,
        'type': (0, DealType_1.DealTypeToJSON)(value.type),
        'dsp': (0, DspProvider_1.DspProviderToJSON)(value.dsp),
        'dsp_partner': (0, DspPartner_1.DspPartnerToJSON)(value.dspPartner),
        'placements': (value.placements.map(DealPlacements_1.DealPlacementsToJSON)),
        'ad_formats': (value.adFormats.map(DealAdFormats_1.DealAdFormatsToJSON)),
        'video_delivery_formats': value.videoDeliveryFormats === undefined ? undefined : (Array.from(value.videoDeliveryFormats).map(VideoDeliveryFormat_1.VideoDeliveryFormatToJSON)),
        'price_floor_micro_amount': value.priceFloorMicroAmount,
        'budget_micro_amount': value.budgetMicroAmount,
        'currency_code': value.currencyCode,
        'targets': (0, Targets_1.TargetsToJSON)(value.targets),
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'category': value.category,
        'archived_at': value.archivedAt === undefined ? undefined : (value.archivedAt.toISOString()),
        'paused_at': value.pausedAt === undefined ? undefined : (value.pausedAt.toISOString()),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'accepted_at': value.acceptedAt === undefined ? undefined : (value.acceptedAt.toISOString()),
        'buyer_paused_at': value.buyerPausedAt === undefined ? undefined : (value.buyerPausedAt.toISOString()),
        'current_negotiation': (0, DealNegotiation_1.DealNegotiationToJSON)(value.currentNegotiation),
        'media_duration_ms': value.mediaDurationMs,
        'frequency_caps': value.frequencyCaps === undefined ? undefined : (Array.from(value.frequencyCaps).map(FrequencyCap_1.FrequencyCapToJSON)),
    };
}
exports.DealToJSON = DealToJSON;
